import { useEffect } from "react";
import { useToast } from "./useToast";
import { localStorageKeyNames, routePaths } from "../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";

function useVersionCheck(interval = 60000) { // Check every 60s

    const { showToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch(`/version.json?date=${new Date().toISOString()}`, { cache: "no-cache" });
                const data = await response.json();
                if (data.status === 'offline') {
                    localStorage.setItem(localStorageKeyNames.showMaintenanceScreen, 'yes');
                    navigate('/' + routePaths.MAINTENANCE);
                } else {
                    localStorage.setItem(localStorageKeyNames.showMaintenanceScreen, 'no');
                    if (location.pathname === `/${routePaths.MAINTENANCE}`) {
                        navigate('/');
                    }
                }
                if (data.version !== localStorage.getItem(localStorageKeyNames.appVersion)) {
                    console.log('NEW VERSION FOUND')
                    console.log('OLD VERSION', localStorage.getItem(localStorageKeyNames.appVersion))
                    console.log('NEW VERSION', data.version)
                    localStorage.setItem(localStorageKeyNames.appVersion, data.version);
                    localStorage.setItem(localStorageKeyNames.showNewVersionBanner, 'yes');
                    window.location.reload();
                }
            } catch (error) {
                console.error("Version check failed:", error);
            }
        };

        checkVersion();
        const intervalId = setInterval(checkVersion, interval);

        return () => clearInterval(intervalId);
    }, [interval, location.pathname, navigate]);

    useEffect(() => {
        if (localStorage.getItem(localStorageKeyNames.showMaintenanceScreen) === 'yes' && location.pathname !== `/${routePaths.MAINTENANCE}`) {
            navigate('/' + routePaths.MAINTENANCE);
        } else if (localStorage.getItem(localStorageKeyNames.showMaintenanceScreen) === 'no' && location.pathname === `/${routePaths.MAINTENANCE}`) {
            navigate('/');
        }
        if (localStorage.getItem(localStorageKeyNames.showNewVersionBanner) === 'yes') {
            showToast('SUCCESS', 'Actualizamos la versión de la App para mejorar tu experiencia.')
            localStorage.setItem(localStorageKeyNames.showNewVersionBanner, 'no');
        }
    }, [location.pathname, navigate, showToast]);
}

export default useVersionCheck;
